module.exports = __webpack_public_path__ + "img/drizzle-light.9694c6a9.png";